import { useEffect, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { PageTitle } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import {
  getTermsAndConditions,
  getTermsAndConditionsLoading,
} from 'common/redux/termsAndConditions/termsAndConditionsSlice';
import { getTermsAndConditionsThunk } from 'common/redux/termsAndConditions/getTermsAndConditionsThunk';
import authorizationService from 'common/services/security/authorizationService';
import { getFakeClientUser } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import styles from './TermsAndConditionsView.module.scss';
import TermsAndConditionsTabs from './components/TermsAndConditionsTabs/TemrsAndConditionsTabs';

import Policy from '../Policy/Policy';

const TermsAndConditionsView = () => {
  const { t } = useTranslation();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const tAndCsLoading: boolean = useSelector(getTermsAndConditionsLoading);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const tAndCs: { id: string }[] = useSelector(getTermsAndConditions);
  const history = useHistory();
  const isFakeClientUser = useSelector(getFakeClientUser);
  if (isFakeClientUser) {
    history.push('/projects');
  }

  const { policyId } = useParams<{ policyId?: string }>();
  const selectedPolicy =
    tAndCs && tAndCs.find((tAndC) => tAndC.id === policyId);
  const contentRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const shouldShowLinks = tAndCs && tAndCs.length > 0;

  useEffect(() => {
    if (authorizationService.hasValidToken() && !tAndCs && !tAndCsLoading) {
      dispatch(getTermsAndConditionsThunk());
    }

    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, [policyId, contentRef, dispatch, tAndCs, tAndCsLoading]);

  return (
    <div className={`${styles.wrapper} project-overview`}>
      <PageTitle title={t('legalInformation')} size="h1" />

      {shouldShowLinks && (
        <div className="tabs" data-testid="terms-and-conditions-tabs">
          <TermsAndConditionsTabs />

          {selectedPolicy && (
            <div
              ref={contentRef}
              className={styles.tabContent}
              data-testid="terms-and-conditions-tab-content"
            >
              <Policy policy={selectedPolicy} />
              <div className={styles.fade} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TermsAndConditionsView;
